import React, { useState, useEffect } from 'react';
import { Input, Typography, Alert, Space } from 'antd';
import { ValidationResult } from '@src/utils/mml/types';
import styles from './mml-objects.module.css';

const { Text } = Typography;
const { TextArea } = Input;

interface MMLEditorProps {
  initialValue: string;
  onChange: (value: string) => void;
  validationResult: ValidationResult | null;
}

const MMLEditor: React.FC<MMLEditorProps> = ({
  initialValue,
  onChange,
  validationResult,
}) => {
  const [value, setValue] = useState<string>(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div className={styles.editorContainer}>
      <div className={styles.editorHeader}>
        <Text strong>MML Code Editor</Text>
      </div>

      <TextArea
        value={value}
        onChange={handleChange}
        className={styles.editor}
        rows={10}
        placeholder='Enter your MML code here...'
      />

      {validationResult && !validationResult.isValid && (
        <div className={styles.validationResults}>
          <Alert
            message='Validation Failed'
            description={
              <Space direction='vertical'>
                {validationResult.errors.map((error, index) => (
                  <div key={index}>
                    <Text type='danger'>
                      Line {error.line}, Column {error.column}: {error.message}
                    </Text>
                  </div>
                ))}
              </Space>
            }
            type='error'
            showIcon
          />
        </div>
      )}
    </div>
  );
};

export default MMLEditor;
